import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Branch } from "../state/types"

export const useBranchActions = () => {
    const saveActions = useSaveActions()

    const saveBranch = (branch: Branch) => {
        const { save } = saveActions()
        return save(TableName.BRANCHES, branch) as Promise<Branch>
    }

    const removeBranch = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.BRANCHES, id)
    }

    return {
        saveBranch,
        removeBranch
    }
}
